import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type UserProfileResponse =
  paths['/api/v1/user_profiles/{id}']['get']['responses'][200]['content']['application/json']['userProfile'];

export type AddAndMergeUserProfileBody = NonNullable<
  paths['/api/v1/user_profiles/create_and_merge_trading_profiles']['post']['requestBody']
>['content']['application/json'];
export type AddAndMergeUserProfileResponse =
  paths['/api/v1/user_profiles/create_and_merge_trading_profiles']['post']['responses'][200]['content']['application/json'];

export type AddUserProfileBody = NonNullable<
  paths['/api/v1/user_profiles']['post']['requestBody']
>['content']['application/json'];
export type AddUserProfileResponse =
  paths['/api/v1/user_profiles']['post']['responses'][200]['content']['application/json'];

export async function getUserProfile(userProfileId: string) {
  const { data, error } = await client.GET('/api/v1/user_profiles/{id}', {
    params: { path: { id: userProfileId } },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from getUserProfile');
  return data.userProfile;
}

export async function addAndMergeUserProfile(
  body: AddAndMergeUserProfileBody
): Promise<AddAndMergeUserProfileResponse> {
  const { data, error } = await client.POST(
    '/api/v1/user_profiles/create_and_merge_trading_profiles',
    {
      body: body,
      headers: authHeaders()
    }
  );
  if (error) throw error;
  if (!data) throw new Error('Empty response from addAndMergeUserProfile');
  return data;
}

export async function addUserProfile(body: AddUserProfileBody): Promise<AddUserProfileResponse> {
  const { data, error } = await client.POST('/api/v1/user_profiles', {
    body: body,
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from addUserProfile');
  return data;
}
